import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

export default class SummaryPagePaddingUtility {
	/**
	 * Get styles for padding.
	 *
	 * @param selector The selector for the element which should get a padding.
	 * @param theme ...
	 */
	public static getHorizontalPadding(selector: string, theme: ITheme): string {
		const { breakpoint, spacing } = theme;

		const paddings = {
			small: spacing.space150,
			medium: spacing.space200,
			large: spacing.space250,
			xlarge: spacing.space300
		};

		/* XXL in Kompis SkapaTheme is 1920, while Skapas is 1600, so we hardcode it here */
		const xxLargeBreakPoint = 1600;

		return css`
			${selector} {
				padding-left: ${paddings.small / 16}rem;
				padding-right: ${paddings.small / 16}rem;
			}
			@media (min-width: ${breakpoint.medium.width / 16}rem) {
				${selector} {
					padding-left: ${paddings.medium / 16}rem;
					padding-right: ${paddings.medium / 16}rem;
				}
			}
			@media (min-width: ${breakpoint.large.width / 16}rem) {
				${selector} {
					padding-left: ${paddings.large / 16}rem;
					padding-right: ${paddings.large / 16}rem;
				}
			}
			@media (min-width: ${breakpoint.xlarge.width / 16}rem) {
				${selector} {
					padding-left: ${paddings.xlarge / 16}rem;
					padding-right: ${paddings.xlarge / 16}rem;
				}
			}
			@media (min-width: ${xxLargeBreakPoint / 16}rem) {
				${selector} {
					margin: auto;
					max-width: ${xxLargeBreakPoint / 16}rem;
				}
			}
		`;
	}
}
